import { render, staticRenderFns } from "./codappoint.vue?vue&type=template&id=dce4e98c"
import script from "./codappoint.vue?vue&type=script&lang=js"
export * from "./codappoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports